const ChatBotPosition = {
  RIGHT_PANEL_TOP: "right_panel_top",
  RIGHT_PANEL_MIDDLE: "right_panel_middle",
  RIGHT_PANEL_BOTTOM: "right_panel_bottom",
  EMBEDED: "embeded",
};
export default ChatBotPosition;
